import React from "react";
import { useLocalization } from "@fluent/react";
import { ContextForm } from "cerulean";
import { TextInput } from "@narmi/design_system";
import type { ReactLocalization } from "@fluent/react";
import useRevalidateErroringField from "../hooks/useRevalidateErroringField";

const INTERNATIONAL_TAX_ID_REGEX = /^[A-Za-z0-9]{1,20}$/;

const validateInternationalTaxId = (value: string, l10n: ReactLocalization) => {
  if (value && !INTERNATIONAL_TAX_ID_REGEX.test(value)) {
    return l10n.getString(
      "errorTaxId",
      null,
      "Please enter a valid Tax ID/EIN"
    );
  }

  return null;
};

type InternationalTaxIdFieldProps = {
  revalidateErrorsOnBlur?: boolean;
};

const InternationalTaxIdField = ({
  revalidateErrorsOnBlur = false,
}: InternationalTaxIdFieldProps) => {
  const { l10n } = useLocalization();
  const field = "ftin";
  const revalidateErroringField = useRevalidateErroringField(field);

  return (
    <ContextForm.Field
      required
      validate={(value: string) => validateInternationalTaxId(value, l10n)}
      key={field}
    >
      <TextInput
        type="text"
        field={field}
        onBlur={revalidateErrorsOnBlur ? revalidateErroringField : undefined}
        label={l10n.getString(
          "label-foreign-tax-id",
          null,
          "Foreign Tax ID/EIN"
        )}
      />
    </ContextForm.Field>
  );
};

export default InternationalTaxIdField;
